export default __webpack_public_path__ + "static/media/down-arrow-white-icon.ad56e689.svg";